import { render, staticRenderFns } from "./MakeUserTeacherModal.vue?vue&type=template&id=4155f960&"
import script from "./MakeUserTeacherModal.vue?vue&type=script&lang=ts&"
export * from "./MakeUserTeacherModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports